export const AdminMenuSetController = {
    edit(): void {},
    update(): void {},
};
